module.exports = __webpack_public_path__ + "img/(9).6a783dc4.jpg";